module.exports = __webpack_public_path__ + "static/crowdfunding-app-web-plp-eec08bc7812f72362b75841c5af066f4.png";